export default __webpack_public_path__ + "static/media/maa.715dda9a.png";